"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _style = require("webmotors-react-pj/frame/header/logged/items/notification/style");
var _v = _interopRequireDefault(require("webmotors-react-pj/tag-analytics/v2"));
var _cdn = require("webmotors-react-pj/utils/cdn");
var _utils = require("webmotors-react-pj/utils");
var _config = require("webmotors-react-pj/config");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = () => {
  const handleNotificationShow = () => {
    (0, _v.default)('pj_cockpit_iconeNotificacao', {
      site: {
        subEnvironment: 'homepage'
      },
      page: {
        flowType: 'cockpit',
        pageType: 'cockpit-homepage',
        pageName: '/webmotors/cockpit/homepage',
        'pageName.tier1': 'cockpit',
        'pageName.tier2': 'homepage',
        'pageName.tier3': undefined,
        loadTime: window.performance.timing.navigationStart
      }
    });
  };
  (0, _react.useEffect)(() => {
    (0, _utils.Ajax)({
      url: "".concat(_config.ApiCDN, "/notifications/unread_count"),
      method: 'GET'
    });
  }, []);
  return _react.default.createElement(_style.StyleWrapper, {
    onClick: () => handleNotificationShow()
  }, (0, _cdn.renderCockpitNotifications)());
};
exports.default = _default;